import { EXPIRATION_TYPES } from './consts'
import type { VehicleExpirationNode } from './types.graphql'

export const getVehicleExpirationTypeName = ({
  expiration,
  name,
  fallback = '-',
}: {
  expiration?: VehicleExpirationNode
  name?: string
  fallback?: string
}): string => {
  const resolvedName = name ?? expiration?.expirationType?.name
  if (!resolvedName) return fallback
  return EXPIRATION_TYPES[resolvedName] ?? resolvedName ?? fallback
}
